import { useQuery } from '@tanstack/react-query';
import resolveApiBase from '../../tradingCockpit/apiBase';

const API_BASE = resolveApiBase();
const API_KEY = process.env.REACT_APP_API_KEY || '';
const POLL_MS = 5000;

const resolveUrl = (path) => {
    if (!API_BASE) {
        return path;
    }
    const normalisedBase = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
    return `${normalisedBase}${path.startsWith('/') ? path : `/${path}`}`;
};

const buildHeaders = () => {
    const headers = { Accept: 'application/json' };
    if (API_KEY) {
        headers['x-api-key'] = API_KEY;
    }
    return headers;
};

async function fetchFleet() {
    const response = await fetch(resolveUrl('/api/insights/fleet'), {
        headers: buildHeaders(),
    });
    if (!response.ok) {
        const text = await response.text();
        throw new Error(`${response.status}: ${text}`);
    }
    return response.json();
}

export function useFleet() {
    return useQuery({
        queryKey: ['insights', 'fleet'],
        queryFn: fetchFleet,
        staleTime: 3000,
        refetchInterval: POLL_MS,
    });
}
